<div class="survey-container">
    <survey [model]="survey"></survey>
</div>